import { axiosAuth } from './axiosInstances'

// KHAN-232: REST/Django naming standardization. El backend paso de
// studentsgroups/{insertnewStudentsGroups,listAllStudentsGroups,
// searchStudentsGroups,deleteStudentsGroups} (verbos en el path, con
// searchStudentsGroups siendo un POST y deleteStudentsGroups un PUT) a un
// unico recurso REST students-groups/ con metodo HTTP por operacion + el
// filtro ?group=. Se preservan los nombres de las funciones exportadas y
// sus parametros para no tocar a los consumidores (Group.jsx, ListGroups.jsx,
// MyClasses.jsx).
export async function newStudentGroup(
  userid,
  isteacher,
  createdby,
  groupscreateid
) {
  return axiosAuth().post(
    'students-groups/',
    {
      userid: userid,
      isteacher: isteacher,
      createdby: createdby,
      groupscreateid: groupscreateid
    }
  )
}

export async function listedStudentGroups() {
  return axiosAuth().get('students-groups/')
}

export async function studentGroupSearch(groupId) {
  return axiosAuth().get(`students-groups/?group=${groupId}`)
}

// `userId` es en realidad el studentsgroupsid de la fila a quitar (ver
// Group.jsx/ListGroups.jsx) -- se conserva el nombre del parametro tal como
// estaba en el archivo original para minimizar el diff.
export async function deleteStudentGroup(userId) {
  return axiosAuth().delete(`students-groups/${userId}/`)
}
